import { ADDRESS_BOOK_ENTRIES_FETCH_REQUESTED } from './actionTypes';

export const fetchAddressBookEntries = () => ({
  type: ADDRESS_BOOK_ENTRIES_FETCH_REQUESTED,
});
